import { Trans } from "@lingui/react/macro";
import { Box, Flex } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import CreateCategory from "@/features/product-categories/create-product-category/create-category-modal";
import CategoriesTable from "@/features/product-categories/product-categories-table";
import { Can } from "@/shared/providers/casl-provider";

export const Route = createFileRoute(
  "/_app/(multi-location)/admin/products/categories/",
)({
  component: CategoriesPage,
});

function CategoriesPage() {
  return (
    <Box p="lg">
      <Flex align="center" justify="space-between">
        <h1>
          <Trans>Kategorier</Trans>
        </h1>

        <Can I="create" a="ProductCategory">
          <CreateCategory />
        </Can>
      </Flex>

      <CategoriesTable />
    </Box>
  );
}
